import { Stack } from "@mui/material";
import { Button } from "components/ButtonNew";
import { cn } from "utils/styling";

import type { EpcModalActionRow } from "./EPCModalContentFactory";

export const EpcModalActions = ({ actionsRows }: { actionsRows: EpcModalActionRow[] | undefined }) => {
  if (!actionsRows) return null;
  return (
    <Stack alignItems="stretch" className="w-full flex-col gap-3">
      {actionsRows.map((row, rowIndex) => (
        <Stack
          alignItems={row.align ?? "stretch"}
          className={cn("w-full", row.direction === "row" && "gap-3")}
          direction={row.direction ?? "column"}
          key={rowIndex}
        >
          {row.buttons.map((button) => (
            <Button
              className={cn("m-px", button.className)}
              disabled={button.disabled}
              key={button.label}
              onClick={button.onClick}
              size="md"
              variant={button.variant}
            >
              {button.label}
            </Button>
          ))}
        </Stack>
      ))}
    </Stack>
  );
};
